/** Normalize free-text drink search so "60min" matches "60 Minute". */

export function normalizeSearchText(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

/** Compact form without spaces — "60 min" / "60min" both become "60min". */
export function compactSearchText(value: string): string {
  return normalizeSearchText(value).replace(/\s+/g, '');
}

export function searchBlob(...parts: Array<string | null | undefined>): {
  spaced: string;
  compact: string;
} {
  const spaced = normalizeSearchText(parts.filter(Boolean).join(' '));
  return { spaced, compact: spaced.replace(/\s+/g, '') };
}

export function matchesSearchBlob(
  blob: { spaced: string; compact: string },
  query: string,
): boolean {
  const q = normalizeSearchText(query);
  if (!q) return true;
  if (blob.spaced.includes(q)) return true;
  const compactQ = q.replace(/\s+/g, '');
  return compactQ.length > 0 && blob.compact.includes(compactQ);
}

/** Lower score = better. Prefer name/brand prefix hits over loose contains. */
export function searchRank(
  name: string,
  brand: string,
  query: string,
): number {
  const q = normalizeSearchText(query);
  if (!q) return 0;
  const n = normalizeSearchText(name);
  const b = normalizeSearchText(brand);
  const compactQ = q.replace(/\s+/g, '');
  const compactN = n.replace(/\s+/g, '');
  if (n.startsWith(q) || compactN.startsWith(compactQ)) return 0;
  if (b.startsWith(q) || b.replace(/\s+/g, '').startsWith(compactQ)) return 1;
  if (n.includes(` ${q}`) || compactN.includes(compactQ)) return 2;
  if (b.includes(q)) return 3;
  return 4;
}
